import { Type } from 'specified';

const personalDetailsSchema = {
    personalDetails: Type.map(Type.string, Type.unknown)
};
const personalDetailsResponseSpec = Type.interface(personalDetailsSchema);
Type.interface(personalDetailsSchema);
const createAccountResponseSpec = Type.interface({
    accountId: Type.string,
    accountDataToken: Type.string
});

export { createAccountResponseSpec, personalDetailsResponseSpec };
//# sourceMappingURL=specs.js.map
